import styled from 'styled-components';
import { Color } from '../../../common/view/color/color';
import { FontSize, FontWeight } from '../../../common/view/font';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'effect_node_item',
  displayName: 'EffectNodeItem',
})`
  ${CssFuncs.css.padding({ y: '1px' })}
`;

const IconContainer = styled.div.withConfig({
  componentId: 'effect_node_item_icon',
  displayName: 'EffectNodeItem.Icon',
})`
  color: ${Color.white7};

  ${Container}:hover & {
    color: ${Color.white3};
  }

  ${Container}.danger & {
    color: #ed2100;
  }

  ${Container}.danger:hover & {
    color: #ed2100;
  }

  transition: color 0.2s linear;
`;

const Text = styled.div.withConfig({
  componentId: 'effect_node_item_text',
  displayName: 'EffectNodeItem.Text',
})`
  font-size: ${FontSize.l1};
  line-height: 1;
  font-weight: ${FontWeight.base};

  color: ${Color.white7};

  ${Container}:hover & {
    color: ${Color.white3};
  }

  ${Container}.danger & {
    color: #ed2100;
  }

  ${Container}.danger:hover & {
    color: #ed2100;
  }

  transition: color 0.2s linear;
`;

const ActionButton = styled.div.withConfig({
  componentId: 'effect_node_item_action_button',
  displayName: 'EffectNodeItem.ActionButton',
})`
  transition: opacity 0.1s linear;
  opacity: 0;
  ${Container}:hover & {
    opacity: 1;
  }
`;

export const EffectNodeItemStyle = {
  Container,
  IconContainer,
  Text,
  ActionButton,
};
